// NOTE: All colors should be loaded from the '@bufferapp/ui'
// library. I'm keeping here the colors that are not part of that
// library yet so we can work on adding them later.

export const lila = '#E1E6FF'
export const black = '#000000'
export const customGrayA = '#DADADA'
export const lightGreen = '#c8e89e'
export const darkGreen = '#4e5248'
